import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ViContentComponent } from '@vi-iot/ui/layouts/content/content.component';

@Component({
  selector: 'vi-content-item',
  templateUrl: 'content-item.component.html',
  styleUrls: ['content-item.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViContentItemComponent extends ViContentComponent {
  @Input() leftColumnWidth: string = 'calc(50% - 12px)';
  @Input() rightColumnWidth: string = 'calc(50% - 12px)';
}
